import Actions from "./FrazioniActions";
import { Frazione } from "../generated";
import { AbstractLookupStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";

export class FrazioniStore extends AbstractLookupStore<Frazione> {
    constructor() {
        super();
        Dispatcher
            .onfunction(Actions.search, data => {
                this.set(data.codFisComune, data.frazioni!);
            })
            ;
    }
}

export default new FrazioniStore();